import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { toast } from "react-toastify";

const handleError = (error, context) => {
  console.error(`API - ${context} error:`, error);
  if (error.response) {
    const { status, data } = error.response;
    if (status === 404) {
      // Return empty array for 404 to indicate no resources found
      return { status, data: [] };
    }
    switch (status) {
      case 400:
        return data.message || "Bad request. Please check your input.";
      case 401:
        localStorage.clear();
        window.location.href = "/";
        return "Session expired. Please log in again.";
      case 403:
        return "You do not have permission to perform this action.";
      case 409:
        return data.message || "Request already exists.";
      case 500:
        return "Server error. Please try again later.";
      default:
        return data.message || "An unknown error occurred.";
    }
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

// Fetch all requests for the dashboard
export const fetchDashboardAllRequests = createAsyncThunk(
  "dashboard/fetchAllRequests",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/RequestSetting/unified-requests", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      return response.data;
    } catch (error) {
      const errorResult = handleError(error, "fetchDashboardAllRequests");
      if (errorResult.status === 404) {
        // Return empty array for 404
        return errorResult.data;
      }
      toast.error(errorResult);
      return rejectWithValue(errorResult);
    }
  },
);

// Fetch pending requests for the dashboard
export const fetchDashboardPendingRequests = createAsyncThunk(
  "dashboard/fetchPendingRequests",
  async (_, { rejectWithValue }) => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        throw new Error("User ID is missing. Please log in again.");
      }
      const response = await api.get(`/RequestSetting/pending/${userId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      return response.data;
    } catch (error) {
      const errorResult = handleError(error, "fetchDashboardPendingRequests");
      if (errorResult.status === 404) {
        // Return empty array for 404
        return errorResult.data;
      }
      toast.error(errorResult);
      return rejectWithValue(errorResult);
    }
  },
);
